import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import { FEATURE_FLAG_NAMES } from 'yeself-common/typings/FeatureFlags';

import Feature from 'yeself-client-common/featureFlags/components/Feature';

import ToursExpansionPanel from 'Console/components/applications/detail/contextHelp/composition/ToursExpansionPanel';
import JourneysExpansionPanel from 'Console/components/applications/detail/contextHelp/composition/JourneysExpansionPanel';
import ArticlesExpansionPanel from 'Console/components/applications/detail/contextHelp/composition/ArticlesExpansionPanel';

const styles = () => ({
    formRoot: {
        display: 'flex',
        flexDirection: 'row',
        flex: 1,
    },
    root: {
        display: 'flex',
        flexWrap: 'nowrap',
    },
});

const CompositionContainer = ({ classes, form }) => (
    <Grid container className={classes.root} direction="column" justify="flex-start" spacing={16}>
        <Feature name={FEATURE_FLAG_NAMES.TOUR}>
            <Grid item>
                <ToursExpansionPanel form={form} />
            </Grid>
        </Feature>

        <Feature name={FEATURE_FLAG_NAMES.PLAYLISTS}>
            <Grid item>
                <ToursExpansionPanel form={form} isPlaylistSubType />
            </Grid>
        </Feature>

        <Feature name={FEATURE_FLAG_NAMES.JOURNEYS}>
            <Grid item>
                <JourneysExpansionPanel form={form} />
            </Grid>
        </Feature>

        <Feature name={FEATURE_FLAG_NAMES.ARTICLES}>
            <Grid item>
                <ArticlesExpansionPanel form={form} />
            </Grid>
        </Feature>
    </Grid>
);

export default withStyles(styles)(CompositionContainer);
